import { WarningOutline18Icon } from "@vygruppen/spor-icon-react";
import { InvisibleButton } from "features/VehicleSidebar/VehicleList/TrainList/styles";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Spor";
import { TextTooltip } from "shared/components/TextTooltip";
import { CountryCode } from "shared/types/countryCode";

export const HasCancellationsIcon = ({
  countryCode,
  withTooltip,
}: {
  countryCode: CountryCode;
  withTooltip?: boolean;
}) => {
  const { t } = useTranslation();

  const text = t("Innstilt fra {{infrastructureProvider}}", {
    infrastructureProvider: countryCode === "SE" ? "TRV" : "BN",
  });

  return withTooltip ? (
    <TextTooltip showArrow label={text} placement="top">
      <InvisibleButton>
        <WarningOutline18Icon color="icon.warning" />
      </InvisibleButton>
    </TextTooltip>
  ) : (
    <>
      <WarningOutline18Icon color="icon.warning" />
      <Text variant="sm">{text}</Text>
    </>
  );
};
